<template>
  <div class="form-control">
    <label>{{ value.label }}</label>
    <select v-model="value.value" ref="select" v-on:change="updateSelectFacet()">
      <option :value="option.slug" v-for="(option, index) in value.children" :key="index">{{ option.name }}</option>
    </select>
    <span class="bss-icon-chevron-down drop-down-arrow"></span>
  </div>
</template>

<script>
export default {
  props: ["value"],
  methods: {
    updateSelectFacet() {
      this.$emit("input", this.getUpdatedValueFromInput());
    },
    getUpdatedValueFromInput() {
      return _.assign({}, this.value, {
        value: this.$refs.select.value
      });
    }
  }
};
</script>